class CollectionCard extends HTMLElement {
  constructor() {
    super();
    this.buttons = this.querySelector('.card-information__buttons');
    this.playButton = this.querySelector('.play');
    this.productHandle = this.dataset.handle;
    this.badgeContainer = this.querySelector('[data-product-badge]');
    this.sectionsRendered = false;
    this.addEventListener('mouseover', this.renderHoverSection.bind(this));
    this.addEventListener('click', this.onClick.bind(this));

    // Get playlist JSON and parse it safely
    this.playlistJSON = this.querySelector('.metafield-json');
    if (!this.playlistJSON) return;
    try {
      this.playlist = JSON.parse(this.playlistJSON.innerText);
    } catch (e) {
      console.error('Invalid playlist JSON', e);
      this.playlist = null;
    }
    this.audioPlayer = document.querySelector('audio-player');
  }

  onClick(event) {
    if (event.target.classList.contains('filter-refine')) {
      event.preventDefault();
      this.handleFilterRefineClick(event);
      return false;
    }
    if (event.target.classList.contains('single-play')) {
      event.preventDefault();
      this.handlePlayClick(event);
      return false;
    }
    if (event.target.classList.contains('single-pause')) {
      event.preventDefault();
      this.handlePauseClick(event);
      return false;
    }
  }

  handleFilterRefineClick(event) {
    Globals.internalClick = true;
    const newUrl = event.target.getAttribute('href');
    FilterApi.updateParamsFromUrl(newUrl);
    FilterApi.applyFilter();
  }

  handlePlayClick(event) {
    if (!this.audioPlayer || !this.playlist) return;
    this.audioPlayer.collectionPlaylist = this;
    if (this.audioPlayer.playlist == this.playlist) {
      this.audioPlayer.elements.playBtn.click();
      return;
    }
    this.audioPlayer.setPlaylist(this.playlist);
    this.audioPlayer.init(this);
    this.audioPlayer.onPlay(event);
  }

  handlePauseClick(event) {
    if (!this.audioPlayer) return;
    this.audioPlayer.onPause(event);
  }

  renderHoverSection() {
    if (this.sectionsRendered) return;
    this.renderHoverSections();
    this.sectionsRendered = true;
  }

  renderHoverSections() {
    // Fetch both sections in one call using 'sections' param
    const url = `${window.routes.root_url}/products/${this.productHandle}/?sections=variant-buttons,variant-badge`;
    fetch(url)
      .then(response => response.json())
      .then(data => {
        if (data['variant-buttons']) {
          this.injectButtonsSection(data['variant-buttons']);
        }
        if (data['variant-badge']) {
          this.injectBadgeSection(data['variant-badge']);
        }
      })
      .catch(e => {
        console.error('Failed to fetch hover sections', e);
      });
  }

  injectButtonsSection(html) {
    if (!this.buttons) return;
    try {
      this.buttons.innerHTML = html;
    } catch (e) {
      console.error('Failed to inject variant buttons section', e);
    }
  }

  injectBadgeSection(html) {
    if (!this.badgeContainer) return;
    try {
      this.badgeContainer.innerHTML = html;
    } catch (e) {
      console.error('Failed to inject variant badge section', e);
    }
  }

}

export default CollectionCard; 